import type { SendEmailFormData } from "@/components/shared/formElements/SendEmailForm";
import { plainTextToHtml } from "./text-to-html";

export function toSendEmailTaskParameters(data: SendEmailFormData) {
  return {
    Subject: data.subject,
    Body: plainTextToHtml(data.message),
    SendAdminCopy: data.sendAdminCopy,
  };
}
